import React from "react";
import { Link } from "react-router-dom";
import { Target, Eye, Heart, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import Seo from "@/components/Seo";
import PublicLayout from "@/components/layout/PublicLayout";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Section";

export default function About() {
  const vals = [
    { icon: Target, t: "Our Mission", d: "To connect the right talent with the right opportunity through a professional, structured and transparent recruitment process." },
    { icon: Eye, t: "Our Vision", d: "To become Karnataka's most trusted manpower and HR partner for businesses and job seekers alike." },
    { icon: Heart, t: "Our Values", d: "Integrity, local commitment, people-first service and genuine long-term relationships." },
  ];
  return (
    <PublicLayout>
      <Seo title="About Us" description="Dreamzz HR & Consultancy is a professional manpower recruitment and HR consultancy serving businesses and job seekers across Karnataka." />
      <PageHeader eyebrow="About Us" title="Professional Recruitment, Rooted Locally" subtitle="Dreamzz HR & Consultancy connects talent with opportunity across Karnataka." />
      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        <p className="text-slate-300 leading-relaxed text-lg">
          Dreamzz HR & Consultancy is a manpower recruitment, staffing and HR consultancy firm headquartered in Chikkamagaluru, Karnataka. We help businesses build strong teams and help job seekers find meaningful work — with a structured, professional and people-first approach.
        </p>
        <p className="text-slate-300 leading-relaxed mt-4">
          From blue-collar and skilled workforce to white-collar and professional roles, we serve a wide range of industries including hospitality, manufacturing, logistics, retail, security and more. Our deep local presence across Karnataka lets us understand both employer needs and candidate aspirations.
        </p>
        <div className="mt-10 grid sm:grid-cols-3 gap-4">
          {vals.map((v, i) => (
            <Reveal key={v.t} delay={i * 60}>
              <div className="glass card-hover rounded-2xl p-6 h-full">
                <v.icon size={28} className="text-brand-emerald" />
                <h3 className="font-display font-bold text-lg mt-3">{v.t}</h3>
                <p className="text-sm text-slate-400 mt-2">{v.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="mt-12 glass-strong rounded-2xl p-8 text-center">
          <h3 className="font-display text-2xl font-bold">Work With Dreamzz HR</h3>
          <div className="mt-6 flex flex-wrap gap-3 justify-center">
            <Link to="/for-employers"><Button className="bg-brand-emerald hover:bg-[#C62828] text-white font-semibold">Hire Talent <ArrowRight size={16} className="ml-2" /></Button></Link>
            <Link to="/jobs"><Button variant="outline" className="border-white/15">Find Jobs</Button></Link>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
